import { Typography } from '@material-ui/core';
import PageContainer from '../../components/PageContainer';
import TopBar from '../../components/TopBar';
import { useStyles } from './styles';
import BottomBar from '../../components/BottomBar';
import waveBottomImg from '../../assets/wave2.png';
import Subdivision from '../../components/Subdivision';
import MenuLink from '../../components/MenuLink';
import { useEffect } from 'react';
import { useTheme } from '../../hooks/useTheme';

function Entities() {
  const classes = useStyles();
  const { changeTheme } = useTheme();
  useEffect(() => {
    window.scrollTo(0, 0);
    changeTheme();
  }, [])
  return(
    <>
      <TopBar>
        <Typography variant="h1">
          Entidades e Órgãos
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography variant="body1" color="textPrimary">
            Aqui você tem acesso a links de Entidades e Órgãos relacionados a pessoa idosa.
          </Typography>
          <div className={classes.container}>
            <MenuLink href="http://www.capital.sp.gov.br/cidadao/familia-e-assistencia-social/centros-de-acolhida/centros-de-acolhida-especial/instituicao-de-longa-permanencia-para-idoso-ilpi">
              Prefeitura de São Paulo - Serviços para Cidadão
            </MenuLink>            
            <MenuLink href="http://www.conselhodoidoso.sp.gov.br/">
              Site do Conselho Estadual do Idoso
            </MenuLink>
            <MenuLink href="https://www.gov.br/mdh/pt-br/acesso-a-informacao/participacao-social/old/conselho-nacional-dos-direitos-do-Idoso-CNDI/notas-publicas/nota-publica-cndi-e-a-maioridade-penal#:~:text=Criado%20em%2013%20de%20maio,vida%20desta%20parcela%20da%20popula%C3%A7%C3%A3o.">
              Conselho Nacional dos Direitos do Idoso (CNDI)
            </MenuLink>
            <MenuLink href="http://www.mds.gov.br/webarquivos/publicacao/assistencia_social/perguntas_e_respostas/PerguntasFrequentesSCFV_032017.pdf">
              Serviço de Convivência e Fortalecimento de Vínculos (SCFV)
            </MenuLink>
            <MenuLink href="http://www.mds.gov.br/webarquivos/publicacao/assistencia_social/perguntas_e_respostas/FAQ_Port_631_BPC_22_04_2019.pdf">
              CadÚnico - Inclusão de beneficiários do Benefício de Prestação Continuada no Cadastro Único
            </MenuLink>
            <MenuLink href="https://www.gov.br/anvisa/pt-br/assuntos/servicosdesaude/instituicoes-de-longa-permanencia-para-idosos">
              Instituições de Longa Permanência para Idosos (ILPIs)
            </MenuLink>
            <MenuLink href="http://www.mds.gov.br/webarquivos/publicacao/assistencia_social/Revista/Cras_Umlugar_fazer_historias.pdf">
              CRAS, um lugar de (re)fazer histórias
            </MenuLink>
            <MenuLink href="http://www.mds.gov.br/webarquivos/publicacao/assistencia_social/cartilhas/perguntas-respostascreas.pdf">
              CREAS
            </MenuLink>
            <MenuLink href="http://www.mpsp.mp.br/portal/page/portal/Cartilhas/Guia%20Pratico%20de%20Direitos%20da%20Pessoa%20Idosa.pdf">
              Guia Prático de Direitos da Pessoa Idosa
            </MenuLink>
            <MenuLink href="http://www.mpsp.mp.br/portal/page/portal/Cartilha_Eletronica/cartilha_saude_cidadao_servicos/saude_cidadao_servicos.html">
              Saúde Cidadão - Guia de serviços para a pessoa idosa
            </MenuLink>
          </div>
        </div>
      </PageContainer>
      <div className={classes.waveBottom}>
        <img src={waveBottomImg} alt="onda"/>
      </div>
      <BottomBar/>
    </>
  );
}

export default Entities;